import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DATE_RANGE_CUSTOM } from '../../../config/filterOptions';

const RangeModal = ({ onUpdate, show, onHide }) => {
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const updateInput = func => e => {
    // if (errorText) {
    //   setErrorText(null);
    // }

    func(e.target.value);
  };

  const selectRange = () => {
    onUpdate({ value: `[${[start, end]}]`, label: `${start} - ${end} Days` });
    onHide();
  };

  return (
    <Modal
      className="tvt-filters__input-date-modal"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Date Range</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="tvt-daysFromRelease-filter__modal-input-wrapper">
          <div className="tvt-daysFromRelease-filter__modal-input-start">
            <span>START</span>{' '}
            <input
              type="number"
              onChange={updateInput(setStart)}
              value={start}
            />
          </div>
          <FontAwesomeIcon
            className="tvt-daysFromRelease-filter__arrow-right-icon"
            icon="arrow-right"
            size="1x"
          />
          <div>
            <input type="number" onChange={updateInput(setEnd)} value={end} />{' '}
            <span>END</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button bsSize="sm" className="tvt-filters__btn" onClick={selectRange}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const DaysFromReleaseFilter = ({ onChange, value, ...props }) => {
  const [range, setRange] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const onCloseModal = () => {
    setModalOpen(false);
  };

  const onSelect = selectedOption => {
    if (!selectedOption || selectedOption.value === null) {
      onChange(null);
    } else if (selectedOption.value === DATE_RANGE_CUSTOM) {
      setModalOpen(true);
    } else {
      onChange(selectedOption);
    }
  };

  useEffect(() => {
    if (!value || !value.value) {
      setRange(null);
    } else {
      setRange(value);
    }
  }, [value]);

  return (
    <>
      <Select {...props} onChange={onSelect} value={range} />
      <RangeModal
        className="tvt-filters__input-date-modal"
        show={modalOpen}
        onHide={onCloseModal}
        onUpdate={onChange}
      />
    </>
  );
};

DaysFromReleaseFilter.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFuture: PropTypes.bool
};

DaysFromReleaseFilter.defaultProps = {
  value: null,
  isFuture: false
};

export default DaysFromReleaseFilter;
